export default __webpack_public_path__ + "static/media/acms-project.5fa675d6.svg";